import { EncodingPlaceholder } from '@bingads-webui-campaign-react/video-status-placeholder-pure-component';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getPlaceholderStyle } from './styles';

export const EncodingPlaceholderWithStyle = withDefaultStyles(EncodingPlaceholder, getPlaceholderStyle);
